<template>
<div>
    <div class="dekstop-view">
        <div class="tableFixHead sticky2">
            <table>
                <thead>
                    <tr>
                        <th @click="clickThead(index)" style="cursor:pointer" v-for="(item, index) in th" :key="index" :style="loadStyle(index)">
                            <span style="float:left">{{item}}</span>
                            <img :src="sortIcon[index]" width="16px" height="16px" style="float:right"/>
                        </th>
                    </tr>
                </thead>
            </table>
        </div>
        <div class="content-sticky">
            <CRow>
                <CCol sm="12">
                    <div class="tableFixHead">
                        <table>
                            <tbody v-if="data.length == 0">
                                <tr>
                                    <td class="text-center" colspan="5">
                                        {{errors}}
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr v-for="(body, id) in data" :key="id" @click="goDetail(id)" class="rows">
                                    <td :style="loadStyle(0)">
                                        <CRow>
                                            <CCol sm="3">
                                                <a v-if="body.urlFoto == null || body.urlFoto == 'null' || body.urlFoto == '' || body.urlFoto == undefined">
                                                    <img :src="photo" width="32px" height="32px" style="border-radius:50%;background-color:#dcdcdc"/>
                                                </a>
                                                <a v-else target="_blank" :href="body.urlFoto">
                                                    <img :src="body.urlFoto" @error="changeDefault" width="32px" height="32px" style="border-radius:50%;background-color:#dcdcdc;object-fit: cover"/>
                                                </a>
                                            </CCol>
                                            <CCol sm="9">
                                                {{body.nama}}
                                            </CCol>
                                        </CRow>
                                    </td>
                                    <td :style="loadStyle(1)">
                                        {{body.nik}}
                                    </td>
                                    <td class="elips" :style="loadStyle(2)">
                                        <span :title="body.email">
                                            {{body.email}}
                                        </span>
                                    </td>
                                    <td :style="loadStyle(3)">
                                        {{body.sex}}
                                    </td>
                                    <td :style="loadStyle(4)">
                                        {{body.keteranganTipePegawai}}
                                    </td>
                                    <td class="elips" :style="loadStyle(5)">
                                        <span v-if="body.bidang == 'null'">
                                            -
                                        </span>
                                        <span v-else :title="body.bidang">
                                            {{body.bidang}}
                                        </span> 
                                    </td>
                                    <td class="elips" :style="loadStyle(6)">
                                        <span v-if="body.jabatan == 'null'">
                                            -
                                        </span>
                                        <span v-else :title="body.jabatan">
                                            {{body.jabatan}}
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </CCol>
            </CRow>
        </div>
    </div>
    <div class="mobile-view">
        <CRow class="mt-3">
            <CCol sm="12">
                <div>
                    <table class="table-responsive">
                        <thead>
                            <tr>
                                <th @click="clickThead(index)" style="cursor:pointer" v-for="(item, index) in th" :key="index">
                                    <span style="float:left">{{item}}</span>
                                    <img :src="sortIcon[index]" width="16px" height="16px" style="float:right"/>
                                </th>
                            </tr>
                        </thead>
                        <tbody v-if="data.length == 0">
                            <tr>
                                <td class="text-center" colspan="5">
                                    {{errors}}
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr v-for="(body, id) in data" :key="id" @click="goDetail(id)" class="rows">
                                <td :style="loadStyle(0)">
                                    <CRow>
                                        <CCol sm="3">
                                            <a v-if="body.urlFoto == null || body.urlFoto == 'null' || body.urlFoto == '' || body.urlFoto == undefined">
                                                <img :src="photo" width="32px" height="32px" style="border-radius:50%;background-color:#dcdcdc"/>
                                            </a>
                                            <a v-else target="_blank" :href="body.urlFoto">
                                                <img :src="body.urlFoto" @error="changeDefault" width="32px" height="32px" style="border-radius:50%;background-color:#dcdcdc"/>
                                            </a>
                                        </CCol>
                                        <CCol sm="9">
                                            {{body.nama}}
                                        </CCol>
                                    </CRow>
                                </td>
                                <td :style="loadStyle(1)">
                                    {{body.nik}}
                                </td>
                                <td class="elips" :style="loadStyle(2)">
                                    <span :title="body.email">
                                        {{body.email}}
                                    </span>
                                </td>
                                <td :style="loadStyle(3)">
                                    {{body.sex}}
                                </td>
                                <td :style="loadStyle(4)">
                                    <span v-if="body.tipePegawai == '1'">Pegawai</span>
                                    <span v-if="body.tipePegawai == '2'">TKO</span>
                                    <span v-if="body.tipePegawai == '3'">Magang</span>
                                    <span v-if="body.tipePegawai == '4'">PKL</span>
                                </td>
                                <td class="elips" :style="loadStyle(5)">
                                    <span v-if="body.bidang == 'null'">
                                        -
                                    </span>
                                    <span v-else :title="body.bidang">
                                        {{body.bidang}}
                                    </span> 
                                </td>
                                <td class="elips" :style="loadStyle(6)">
                                    <span v-if="body.jabatan == 'null'">
                                        -
                                    </span>
                                    <span v-else :title="body.jabatan">
                                        {{body.jabatan}}
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
export default {
    props: ['data', 'th', 'td', 'styleTable', 'errors'],
    data() {
        return {
            sortIcon: [],
            photo: require('@/assets/image/images.svg'),
        }
    },
    mounted() {
        this.iconLoad('unsort', 'none')
    },
    watch: {
    },
    methods: {
        clickThead(index) {
            this.$emit('sort', index)
            this.iconLoad('sort', index)
        },
        goDetail(id) {
            this.$emit('detail', id)
        },
        goEdit(id) {
            this.$emit('edit', id)
        },
        loadStyle(index) {
            return 'width:' + this.styleTable[index] + ';' + 'max-width:' + this.styleTable[index]
        },
        iconLoad(type, index) {
            this.sortIcon = []
            let length = this.th.length
            var i = 0
            if (type == 'sort') {
                for(i=0;i<length;i++) {
                    let onPush = ''
                    if(index == i) {
                        onPush = require('../assets/menu/sort_normal.svg')
                    } else {
                        onPush = require('../assets/menu/sort_active.svg')
                    }
                    this.sortIcon.push(onPush)
                }
            } else {
                for(i=0;i<length;i++) {
                    let onPush = require('../assets/menu/sort_active.svg')
                    this.sortIcon.push(onPush)
                }
            }
        },
        separatorHari(value) {
            if(value == 1) {
                return 'Senin'
            } else if(value == 2) {
                return 'Selasa'
            } else if(value == 3) {
                return 'Rabu'
            } else if(value == 4) {
                return 'Kamis'
            } else if(value == 5) {
                return 'Jumat'
            } else if(value == 6) {
                return 'Sabtu'
            } else if(value == 7) {
                return 'Minggu'
            }
        },
        changeDefault(e) {
            e.target.src = this.photo
        }
    },
}
</script>

<style scoped>
@media only screen and (max-width:1278px) {
  .dekstop-view {
      display: none;
  }
}
@media only screen and (min-width:1279px) {
  .mobile-view {
      display: none;
  }
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    color: rgba(0, 0, 0, 1);
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}
td, th {
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
.rows:hover {
    cursor: pointer;
    background-color: whitesmoke;
}
.elips {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
div.sticky2 {
    position: -webkit-sticky;
    position: sticky;
    top: 105px;
    background-color: white;
    z-index: 1;
}
.content-sticky {
    background-color: white;
}
.btn-edit {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: white;
    color: black;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
    float:right;
}
.btn-edit:hover {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: rgba(154, 154, 154, 1);
    color: white;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
    float:right;
}
</style>